import React, { useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "aos/dist/aos.css";
import AOS from "aos";
import "react-accessible-accordion/dist/fancy-example.css";
import "./../../HomePage/Faq/Faq.css";
const ApostilleFaqMain = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
  }, []);
  return (
    <div className="faqMainContainer">
      <Accordion className="faqMainContent" allowZeroExpanded>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is an Apostille and why is it required?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="faqPanel">
            <p>
              An Apostille is a government-issued sticker that certifies a
              document’s authenticity for use in any Hague Convention country.
              You need Apostille for:
              <ul>
                <li> Job Visa / Employment</li>
                <li> Higher Studies Abroad</li>
                <li> Migration & PR</li>
                <li> Work Permits</li>
                <li> Marriage / Family Visa</li>
                <li> Medical & Legal Use Abroad</li>
              </ul>
              Without Apostille, foreign authorities will not accept your
              documents.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Which documents can be Apostilled in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Common documents include:
              <ul>
                <li>
                  {" "}
                  <b>Educational:</b> Degree, Diploma, Transcripts, Mark Sheets
                </li>
                <li>
                  {" "}
                  <b>Personal:</b> Birth, Marriage, PCC, Medical, Divorce
                </li>
                <li>
                  <b>Commercial:</b> Power of Attorney, Certificate of
                  Incorporation, Invoices
                </li>
              </ul>
              Each document type has a different Apostille flow.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long does Apostille processing take?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Timelines depend on document type and verification required:
              <ul>
                <li> Personal documents: 1–3 working days</li>
                <li> Educational documents: 3–7 working days</li>
                <li> Commercial documents: 2–5 working days</li>
              </ul>
              Some agencies offer same-day and express Apostille depending on
              MEA workload.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3> What documents do I need to submit for Apostille? </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Most Apostille requests need:
              <ul>
                <li> Original Certificate (non-laminated)</li>
                <li> Passport Copy</li>
                <li> Aadhaar / ID Proof</li>
                <li> Authorization Letter (for agency processing)</li>
              </ul>
              Educational documents may require provisional + consolidated
              marksheets.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is Apostille the same as Embassy Attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              <b> No.</b>
              Apostille is used only for Hague Convention countries (e.g.,
              Germany, France, Italy, Netherlands, USA, etc.). Embassy
              Attestation is required for non-Hague countries (e.g., UAE, Qatar,
              Kuwait, Saudi). Both processes are different and not
              interchangeable.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is it safe to give my original documents for Apostille?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes—if you choose a Govt-authorized, ISO-certified agency. You
              should receive:
              <ul>
                <li> Receipt for every document</li>
                <li> Tracking ID</li>
                <li> Pickup/Drop confirmation</li>
                <li> Status updates (SMS/WhatsApp)</li>
              </ul>
              Avoid unofficial freelancers or home-based agents.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Can Apostille be done without visiting the office?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. Most professional Apostille centers in Bangalore provide:
              <ul>
                <li> Free home pickup & drop</li>
                <li> Online payment</li>
                <li> WhatsApp document submission</li>
                <li> Digital tracking support</li>
              </ul>
              Very convenient for working professionals.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How much does Apostille cost in Bangalore? </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Costs depend on:
              <ul>
                <li> Document category</li>
                <li> Urgency</li>
                <li> MEA fee</li>
                <li> State verification requirement</li>
              </ul>
              Average pricing ranges:
              <ul>
                <li> Personal Documents: ₹1,500 – ₹3,000</li>
                <li> Educational Documents: ₹2,000 – ₹6,000</li>
                <li> Commercial Documents: ₹3,000 – ₹12,000</li>
              </ul>
              Always ask for a transparent fee breakdown.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long is the Apostille valid?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              In India, Apostilled documents have lifetime validity, unless the
              destination country requires:
              <ul>
                <li> Recent PCC (valid for 6 months)</li>
                <li> Recent Medical Certificate</li>
              </ul>
              Educational and personal certificates do not expire.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What are the steps in the Apostille process?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Depending on the document, the steps include:
              <br />
              <b>For Personal Documents:</b>
              <ul>
                <li> SDM/Home Department Verification</li>
                <li> MEA Apostille</li>
              </ul>
              <b>For Educational Documents:</b>
              <ul>
                <li> University Verification (sometimes required)</li>
                <li> HRD/SDM Attestation</li>
                <li> MEA Apostille</li>
              </ul>
              <b>For Commercial Documents:</b>
              <ul>
                <li> Chamber of Commerce</li>
                <li> MEA Apostille</li>
              </ul>
              Each level confirms authenticity.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What problems can delay my Apostille process?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Common issues include:
              <ul>
                <li> Laminated certificates</li>
                <li> Name mismatch with passport</li>
                <li> Fake/Unauthorised university</li>
                <li> Unavailable signatures/seals</li>
                <li> Errors in spelling or wrong details on certificates</li>
                <li> Submitting photocopies instead of originals</li>
                <li> Using unverified agents</li>
              </ul>
              A good agency will pre-check everything to avoid delays or
              rejection.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default ApostilleFaqMain;
